export default __webpack_public_path__ + "static/media/Turmeric.103f79d5.jpg";